import { render, staticRenderFns } from "./UserNav.vue?vue&type=template&id=44d8edae&"
import script from "./UserNav.vue?vue&type=script&lang=ts&"
export * from "./UserNav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserNav.vue"
export default component.exports